import type {ComponentPropertiesMapping} from './types'

// based on https://github.com/wix-private/wix-blocks-client/blob/master/packages/eml-serdes/types/types.ts {@see {@type ComponentProperties}}
export const COMPONENT_PROPERTIES_MAPPING: ComponentPropertiesMapping = [
    {
        from: 'type',
        to: 'tagName'
    },
    {
        from: 'id',
        to: 'semanticId'
    },
    {
        from: 'style.default',
        to: 'style.default'
    },
    {
        from: 'data',
        to: 'data'
    },
    {
        from: 'components',
        to: 'components'
    },
    {
        from: 'layout.default.itemLayout.margins',
        to: 'layout.default.margins'
    }
]
